import React from 'react'

const SvgUndo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.535 8.071c.804-.906 2.308-2.073 4.538-2.075 3.13-.003 5.994 2.484 6 6.004.006 3.52-2.919 6-6 6 0 0-1 0-1 1s1 1 1 1A8 8 0 106 6.792V5a1 1 0 00-2 0v4.071a1 1 0 001 1h4.073a1 1 0 000-2H7.535z'
    />
  </svg>
)

export default SvgUndo
